import Intelligence from 'components/admin/pages/Intelligence';
import AdminIntelligenceAiTask from 'components/admin/pages/Intelligence/AiTask/AdminIntelligenceAiTask';
import AdminIntelligenceModel from 'components/admin/pages/Intelligence/Model/AdminIntelligenceModel';
import AdminIntelligencePrompts from 'components/admin/pages/Intelligence/Prompt/AdminIntelligencePrompts';

const ADMIN_INTELLIGENCE = [
  {
    path: 'intelligence',
    element: <Intelligence />,
    children: [
      {
        path: 'ai_tasks',
        element: <AdminIntelligenceAiTask />
      },
      {
        path: 'models',
        element: <AdminIntelligenceModel />
      },
      {
        path: 'prompts',
        element: <AdminIntelligencePrompts />
      }
    ]
  }
];
export default ADMIN_INTELLIGENCE;
